import { getAngleInDeg } from '@wix/wow-utils';
import { getMouseTransitionEasing } from '../../utils';
import { CustomMouse } from './CustomMouse';
class SpinMouseAnimation extends CustomMouse {
  progress(_ref) {
    let {
      x: progressX,
      y: progressY
    } = _ref;
    const {
      invert,
      axis
    } = this.options;
    const rotation = getAngleInDeg([0.5, 0.5], [axis === 'vertical' ? 0 : progressX, axis === 'horizontal' ? 0 : progressY], 90) * invert;
    this.target.style.transform = `rotate(calc(${rotation}deg + var(--comp-rotate-z, 0deg)))`;
  }
  cancel() {
    this.target.style.transform = '';
    this.target.style.transition = '';
  }
}
export default function create(options) {
  const {
    transitionDuration,
    transitionEasing = 'linear'
  } = options;
  const {
    inverted = false,
    axis = 'both'
  } = options.namedEffect;
  const invert = inverted ? -1 : 1;
  const animationOptions = {
    transition: transitionDuration ? `transform ${transitionDuration}ms ${getMouseTransitionEasing(transitionEasing)}` : '',
    invert,
    axis
  };
  return target => new SpinMouseAnimation(target, animationOptions);
}
//# sourceMappingURL=SpinMouse.js.map